require("./subscriptionHistoryService");

angular.module('app.myProfile.subscriptionHistory.subscriptionHistoryController', [
  'app.myProfile.subscriptionHistory.subscriptionHistoryService'
])

  .controller('subscriptionHistoryController', [
    '$scope', 'subscriptionHistoryService',
    function ($scope, subscriptionHistory) {
      "use strict";
      
      $scope.subscriptionHistory = subscriptionHistory;

      $scope.pager = {
        current_page: 1,
        page_size: 10,
        items: [],
        pageChanged: function () {
          if (Array.isArray(subscriptionHistory.list)) {
            let start_index = ($scope.pager.current_page - 1) * $scope.pager.page_size;
            let stop_index = start_index + $scope.pager.page_size;
            $scope.pager.items = subscriptionHistory.list.slice(start_index, stop_index);
          }
        }
      };

      $scope.plan_total = function (subscription) {
        if (subscription && subscription.plan) {
          let currency = subscription.currency;
          let plan_totals = subscription.plan.total_amount_in_cents;

          if (typeof plan_totals[currency] !== 'undefined') {
            return plan_totals[currency] / 100;
          }
        }
        return '???';
      };

      let init = function () {
        subscriptionHistory.retrieve();
      };

      $scope.$watch(
        function () {
          return subscriptionHistory.list;
        },
        function () {
          $scope.pager.current_page = 1;
          $scope.pager.pageChanged();
        }
      );

      init();
    }
  ]);


// WEBPACK FOOTER //
// ./app.v2/components/myProfile/subscriptionHistory/subscriptionHistoryController.js